<template>
  <div>
    <header-bar>著作権情報詳細</header-bar>
    <div class="page-block">
      <div class="page-block__inner">
        <div class="split-tabs">
          <button
            :class="firstTab ? 'c-btn tab-btn split-tab-active':'c-btn tab-btn split-tab-inactive'"
            @click="onFirstTabSelected">
            作品詳細
          </button>
          <button
            :class="secondTab ? 'c-btn tab-btn split-tab-active':'c-btn tab-btn split-tab-inactive'"
            @click="onSecondTabSelected">
            スプリット詳細
          </button>
        </div>
        <split-confirm
          v-if="showCopyrightDetails">
        </split-confirm>
        <template
          v-if="showCopyrightSplitDetails">
          <div class="copyright-detail-info">
            <div class="top-info-text">
              <div class="copyright-product-title-heading">作品タイトル</div>
              <div class="copyright-product-title-sub-heading">
                {{ items[0].copyrights.title_ja }}
              </div>
            </div>
            <div>
              <button
                v-if="isCancelled"
                class="c-btn"
                @click.prevent="reset()">
                スプリットを再設定する
              </button>
            </div>
          </div>
          <div>
            <table
              v-intersect.once
              class="my-release-list__table">
              <thead class="my-release-list__thead">
                <tr>
                  <th class="link-list__cell-jacket">分配率</th>
                  <th class="link-list__cell-genre">ゲスト</th>
                  <th class="link-list__cell-artist">役割</th>
                  <th class="link-list__cell-title ">ステータス</th>
                  <th class="link-list__cell-title "></th>
                </tr>
              </thead>
              <tbody class="link-list__tbody">
                <tr
                  v-for="item in items"
                  :key="item.id">
                  <td>{{ formattedRate(item.rate) }}%</td>
                  <td>{{ item.email }} <span v-if="item.owner">（管理者)</span></td>
                  <td>{{ mapRoles(item.role) }}</td>
                  <td>{{ getStatusText(item.status) }}</td>
                  <td>
                    <button
                      v-if="item.status === 1"
                      class="c-btn"
                      @click.prevent="resendInvitationMail(item.id)">
                      招待メールの再送信
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="copyright-split-btn-wrap">
            <div
              class="c-btn-wrap">
              <button
                class="c-btn c-btn--back c-btn--back-left"
                @click.prevent="onReturnClicked()">
                著作権管理スプリットトップへ
                <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
              </button>
              <button
                v-if="!isCancelled && !isCompleted"
                class="c-btn"
                @click.prevent="onCancelClicked()">
                スプリットをキャンセルする
                <span class="c-btn__icon-arrow c-btn__icon-arrow--right"></span>
              </button>
              <button
                v-if="isCancelled && !isCompleted"
                class="c-btn"
                @click.prevent="onDeleteClicked()">
                スプリットを削除する
                <span class="c-btn__icon-arrow c-btn__icon-arrow--right"></span>
              </button>
            </div>
          </div>
        </template>
        <confirm-dialog
          name="cancelCopyrightSplits"
          :is-shown="confirmDialog"
          title="著作権スプリットをキャンセルしますか？"
          :is-hover-on-default-button="true"
          @closed="onRejectedClosedClicked()"
          @default-clicked="onDefaultClicked()"
          @cancel-clicked="onRejectedClosedClicked()">
          <template #body>
            キャンセルした場合、<br>
            すべてのゲストに通知されます。
          </template>
        </confirm-dialog>
        <confirm-dialog
          name="cancelledCopyrightSplits"
          :is-shown="showCancelledCopyrightSplitDialog"
          :default-button-title="false"
          :cancel-button-title="false"
          :cross-cancel-button="true"
          @closed="onCloseSuccessDialog()">
          <template #body>
            著作権スプリットをキャンセルしました。
            <div class="mb-spacing" />
          </template>
        </confirm-dialog>
        <confirm-dialog
          name="deleteCopyrightSplits"
          :is-shown="deleteConfirmDialog"
          title="著作権スプリットを削除しますか？"
          :is-hover-on-default-button="true"
          @closed="onRejectedClosedClicked('delete')"
          @default-clicked="onDefaultClicked('delete')"
          @cancel-clicked="onRejectedClosedClicked('delete')">
          <template #body>
            削除されたスプリットの設定は<br>
            復旧できません。
          </template>
        </confirm-dialog>
        <confirm-dialog
          name="deletedCopyrightSplits"
          :is-shown="showDeletedCopyrightSplitDialog"
          :default-button-title="false"
          :cancel-button-title="false"
          :cross-cancel-button="true"
          @closed="onCloseSuccessDialog('delete')">
          <template #body>
            著作権スプリットを削除しました。
          </template>
        </confirm-dialog>
        <confirm-dialog
          name="resendMail"
          :is-shown="resendMail"
          @closed="onRejectedClosedClicked('resend')"
          @default-clicked="onDefaultClicked('resend')"
          @cancel-clicked="onRejectedClosedClicked('resend')">
          <template #body>
            招待メールを再送信しますか？
          </template>
        </confirm-dialog>
        <confirm-dialog
          name="resendCopyrightSplitMail"
          :is-shown="showResendMail"
          :default-button-title="false"
          :cancel-button-title="false"
          :cross-cancel-button="true"
          @closed="onCloseSuccessDialog('resend')">
          <template #body>
            再送信しました。
            <div class="mb-spacing" />
          </template>
        </confirm-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../../HeaderBar'
import SplitConfirm from './Confirm'
import ConfirmDialog from '../../../../components/ConfirmDialog'
import {
  CMAP_COPYRIGHT_SPLIT_STATUS_CANCELLED,
  CMAP_COPYRIGHT_SPLIT_STATUS_COMPLETED,
} from '../../../../consts/status'

export default {
  name: 'SplitDetail',
  components: {
    SplitConfirm,
    HeaderBar,
    ConfirmDialog,
  },
  data() {
    return {
      firstTab: true,
      secondTab: false,
      showCopyrightDetails: false,
      showCopyrightSplitDetails: false,
      confirmDialog: false,
      showCancelledCopyrightSplitDialog: false,
      deleteConfirmDialog: false,
      showDeletedCopyrightSplitDialog: false,
      resendMail: false,
      showResendMail: false,
      isCancelled: false,
      isCompleted: false,
      copyrightId: '',
      splitId: '',
      items: [],
    }
  },
  mounted() {
    const { copyrightId, enableSecondTab } = JSON.parse(window.sessionStorage.getItem('copyright-split')) || {}
    if (copyrightId) {
      this.copyrightId = copyrightId
    } else {
      window.sessionStorage.setItem('copyright-split', JSON.stringify(
        { copyrightId: parseInt(this.$route.params.id, 10) },
      ))
    }
    if (enableSecondTab) {
      this.onSecondTabSelected()
      this.firstTab = false
      this.secondTab = true
    } else {
      this.onFirstTabSelected()
    }
  },
  methods: {
    onFirstTabSelected() {
      this.showCopyrightDetails = true
      this.showCopyrightSplitDetails = false
      this.firstTab = true
      this.secondTab = false
    },
    async onSecondTabSelected() {
      this.secondTab = true
      this.firstTab = false
      const { data } = await window.axios.get(`/api/client/copyright-splits/${this.copyrightId}`)
      if (data.message === 'deleted') {
        this.$router.push({ name: 'index' })
        return
      }
      this.items = data
      if (this.items.every(
        split => split.status === CMAP_COPYRIGHT_SPLIT_STATUS_COMPLETED,
      )) {
        this.isCompleted = true
      } else {
        const combinedData = []
        const owner1Data = data.filter(item => item.owner === 1)
        const owner0Data = data.filter(item => item.owner === 0)

        owner1Data.forEach(item => {
          const existingItem = combinedData.find(obj => obj.owner === item.owner)
          if (existingItem) {
            existingItem.rate += item.rate
            const newRoles = item.role.split(',').filter(role => !existingItem.role.includes(role))
            if (newRoles.length) {
              existingItem.role += `,${newRoles.join(',')}`
            }
          } else {
            combinedData.push({ ...item })
          }
        })
        this.items = [...combinedData, ...owner0Data]
      }
      if (this.items.every(
        split => split.status === CMAP_COPYRIGHT_SPLIT_STATUS_CANCELLED,
      )) {
        this.isCancelled = true
      }
      this.showCopyrightDetails = false
      this.showCopyrightSplitDetails = true
      this.disableButton = false
    },
    onClickedSearch() {
      this.keyword = this.preKeyword
    },
    onReturnClicked() {
      this.$router.push({ name: 'copyright-splits' })
    },
    async onRejectedClosedClicked(type = 'cancel') {
      if (type === 'cancel') {
        this.confirmDialog = false
      } else if (type === 'resend') {
        this.resendMail = false
      } else {
        this.deleteConfirmDialog = false
      }
    },
    async onDefaultClicked(type = 'cancel') {
      if (type === 'cancel') {
        const response = await window.axios.post('/api/client/copyrights/splits/cancel', {
          id: this.copyrightId,
        })
        if (response.data && response.status === 200) {
          this.confirmDialog = false
          this.showCancelledCopyrightSplitDialog = true
          await this.onSecondTabSelected()
        }
      } else if (type === 'resend') {
        await window.axios.post('/api/client/copyrights/splits/resend', {
          id: this.splitId,
        })
        this.resendMail = false
        this.showResendMail = true
      } else {
        const response = await window.axios.post('/api/client/copyrights/splits/delete', {
          id: this.copyrightId,
        })
        if (response.data && response.status === 200) {
          this.deleteConfirmDialog = false
          this.showDeletedCopyrightSplitDialog = true
        }
      }
    },
    onCancelClicked() {
      this.confirmDialog = true
    },
    onDeleteClicked() {
      this.deleteConfirmDialog = true
    },
    onCloseSuccessDialog(type = 'cancel') {
      if (type === 'cancel') {
        this.showCancelledCopyrightSplitDialog = false
        this.isCancelled = true
      } else if (type === 'resend') {
        this.showResendMail = false
      } else {
        this.showDeletedCopyrightSplitDialog = false
        window.location.href = '/client/copyright/splits'
      }
    },
    mapRoles(roles) {
      const mapping = {
        lyricist: '作詞',
        composer: '作曲',
        'co-lyricist': '補作詞者',
        'co-composer': '補作曲者',
      }
      return roles.split(',').map(key => mapping[key]).toString()
    },
    getStatusText(status) {
      let statusText = '承認待ち'
      switch (status) {
        case 3:
          statusText = '完了'
          break
        case 4:
          statusText = 'キャンセル'
          break
        default:
      }
      return statusText
    },
    reset() {
      this.$router.push({ name: 'copyright-edit', params: { id: this.copyrightId } })
    },
    resendInvitationMail(id) {
      this.resendMail = true
      this.splitId = id
    },
    formattedRate(rate) {
      if (!rate) return ''

      return rate !== 100 ? parseFloat(rate).toFixed(1) : '100'
    },
  },
}
</script>

<style scoped>
.split-tab-active {
  background-color: #34458D !important;
  color: #fff !important;
}
.split-tab-inactive {
  background-color: #e6e6e6 !important;
  color: #4b4b4b !important;
}
.my-release-list__thead {
  border-bottom: 2px solid #e8e8e8;
}

.my-release-list__thead th {
  background-color: white;
  text-align: center;
}

@media screen and (min-width: 896px) {
  .my-release-list__thead th {
    border: none;
    font-size: 1.4rem;
    padding: 15px;
  }
}

@media screen and (max-width: 895px) {
  .my-release-list__thead th {
    border: none;
    padding: 2.66667vw;
    white-space: nowrap;
  }
}

.link-list__tbody td {
    border-right: none;
    border-left: none;
}

.link-list__cell-genre {
  width: 150px;
}

.link-list__cell-jacket {
  width: 150px;
}

.link-list__cell-artist {
  width: 150px;
}
</style>
